import React from 'react';
import ResourcesIndexPage from './Resources';

const ResourcesPage: React.FC = () => {
  return <ResourcesIndexPage />;
};

export default ResourcesPage;